import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type ProductsUi = {
  columnHeaders: ColumnHeaderUi[];
  paging?: PagingUi;
  isLoading?: boolean;
  products: ProductUi[];
  searchQuery: string;
  isSearching?: boolean;
};

export type ProductUi = {
  productId: string;
  skuId: string;
  productNumber: string;
  image?: string;
  name: string;
  seller: string;
  price: string;
  presentation: string;
  status?: statusBadgeUi;
};

const tableHeaders = [
  { label: 'Product ID' },
  { label: 'Vendedor' },
  { label: 'Imagen' },
  { label: 'Nombre del Producto' },
  { label: 'Presentación' },
  { label: 'Precio' },
  { label: 'Estatus' },
  { label: '' },
];

export const initialState: ProductsUi = {
  columnHeaders: tableHeaders,
  products: [],
  searchQuery: '',
};
